import { NgModule } from '@angular/core';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
    }),
    StoreModule.forFeature('router', routerReducer),
  ],
})
export class RouterStoreModule {}
